import React from 'react';

import { Typography } from '@mui/material';
import ButtonK from '../Button/ButtonK';
export const MainCard = (props) => {
  const {
    maintext,
    secondaryText,
    thirdText,
    logo,
    buttonText,
    buttonColor,
    buttonbg,
    buttonVarient,
    handleClick,
  } = props;
  return (
    <div style={{ margin: 'auto', width: '100%', textAlign: 'center' }}>
      <img style={{height:'30%',width:'30%'}} src={logo} alt="icon" />
      <Typography
        style={{
          color: '#131F32',
          fontSize: '28px',
          fontWeight: '600',
          marginBottom: '10px',
          marginTop: '10px',
        }}
      >
        {maintext}
      </Typography>
      <Typography style={{ color: '#131F32' }}>{secondaryText}</Typography>
      <div style={{ marginTop: '10px', color: '#131F32' }}>
        {thirdText}
        </div>
        <ButtonK
          text={buttonText}
          color={buttonColor}
          backgroundColor={buttonbg}
          varient={buttonVarient}
          onClick={handleClick}
          sx={{fontSize:'14px !important'}}
        />
    
    </div>
  );
};

export default MainCard;
